import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Link } from 'react-router';
import Fade from 'react-bootstrap/Fade';
import { motion } from 'motion/react';
import { useAuth } from '../../../utils/Auth';
import { variants, transition, smallScreenVariants } from './variants';
import styles from './QuickButtons.module.css';

export default function QuickButtons(props) {
    const { showCard, setShowCard } = props;

    const { route, messageObj } = useAuth();
    const [ open, setOpen ] = useState(false);
    const menuRef = useRef();
    let windowWidth = window.innerWidth;

    const messages = useMemo(() => {
        if (messageObj) {
            return Object.values(messageObj).filter(obj => obj.deleted === 0 && obj.type === 'message').sort((a, b) => a.read === b.read ? 0 : a.read ? 1 : -1);
        }
        return [];
    }, [messageObj]);
    const unread = messages?.filter(message => message.read === false).length;

    useEffect(() => {
        const handleClickOutside = e => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpen(false);
            };
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    },[]);

    return (
        <div className={styles.container}>
            <div className={styles.quickBtnWrap}>
                <motion.div 
                    variants={variants} 
                    transition={transition} 
                    custom={windowWidth}
                    initial='offscreen' 
                    whileInView='onscreen' 
                    viewport={{once: true}}
                >
                    <Link className={styles.quickBtn} to={`/${route}`} title="View Digital Business Card"><i className='far fa-address-card' /></Link>
                </motion.div>
                <motion.div 
                    variants={variants} 
                    transition={windowWidth <= 600 ? {...transition} : {...transition, delay: .2}} 
                    custom={windowWidth}
                    initial='offscreen' 
                    whileInView='onscreen' 
                    viewport={{once: true}}
                >
                    <Link className={styles.quickBtn} to='/inbox' title='Inbox'><i className='far fa-inbox' />{unread > 0 ? <div style={unread.length > 1 ? {fontSize: '.7rem'} : null}>{unread}</div> : <></>}</Link>
                </motion.div>
                <motion.div 
                    variants={variants} 
                    transition={windowWidth <= 600 ? {...transition} : {...transition, delay: .4}} 
                    custom={windowWidth}
                    initial='offscreen' 
                    whileInView='onscreen' 
                    viewport={{once: true}}
                >
                    <Link className={styles.quickBtn} to='/contacts' title='Contacts'><i className='far fa-users' /></Link>
                </motion.div>
                <motion.div 
                    variants={variants} 
                    transition={windowWidth <= 600 ? {...transition} : {...transition, delay: .6}} 
                    custom={windowWidth}
                    initial='offscreen' 
                    whileInView='onscreen' 
                    viewport={{once: true}}
                >
                    <Link className={styles.quickBtn} to='/accountsettings' title='Account Settings' ><i className='far fa-cog' /></Link>
                </motion.div>
            </div>
            <motion.button 
                className={styles.editDBC768} 
                onClick={() => setShowCard(!showCard)}
                custom={windowWidth}
                variants={smallScreenVariants}
                transition={transition}
                initial='offscreen'
                whileInView='onscreen'
                viewport={{once: true}}
            >
                {!showCard ? 'Edit Digital Card' : 'Back to Main'}
            </motion.button>
            <motion.div 
                className={styles.quickBtn768} 
                onClick={() => setOpen(!open)}
                variants={smallScreenVariants}
                transition={transition}
                initial='offscreen'
                whileInView='onscreen'
                viewport={{once: true}}
            >
                <i className='fas fa-ellipsis-vertical' />
                <Fade in={open} style={open ? { display: 'flex' } : { display: 'none' }}>
                    <div className={styles.position} ref={menuRef}>
                        <div className={styles.menu}>
                            <Link className={styles.menuOption} to={`/${route}`} title="View Digital Business Card"><i className='far fa-address-card' /> View Card</Link>
                            <Link className={styles.menuOption} to='/inbox' title='Inbox'><i className='far fa-inbox' />Inbox{unread ? <div style={unread.length > 1 ? {fontSize: '.7rem'} : null}>{unread}</div> : <></>}</Link>
                            <Link className={styles.menuOption} to='/contacts' title='Contacts'><i className='far fa-users' />Contacts</Link>
                            <Link className={styles.menuOption} to='/accountsettings' title='Account Settings'><i className='far fa-cog' />Account Settings</Link>
                        </div>
                    </div>
                </Fade>
            </motion.div>
        </div>
    );
};